import { render, staticRenderFns } from "./TeamManager.vue?vue&type=template&id=1a03550d&scoped=true"
import script from "./TeamManager.vue?vue&type=script&lang=js"
export * from "./TeamManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a03550d",
  null
  
)

export default component.exports